import { Dialog, DialogContent } from "@babackapp/ui/components/dialog";
import { useState } from "react";
import { GenerateDefaultTemplatesRequestDto } from "@babackapp/private-api-client/types";
import { tracking } from "@babackapp/transactional-emails/lib";
import { StatusSelectionStep } from "./status-selection-step";
import { ConfirmationStep } from "./confirmation-step";


export interface StatusSelectionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (
    selectedStatuses: GenerateDefaultTemplatesRequestDto["trackingStatuses"], enableWorkflows: boolean) => void;
}

export function StatusSelectionModal({ open, onOpenChange, onConfirm }: StatusSelectionModalProps) {
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  const [step, setStep] = useState<1 | 2>(1);

  const templatesList = Object.entries(tracking.defaultEmailTemplates) as [
    keyof typeof tracking.defaultEmailTemplates,
    (typeof tracking.defaultEmailTemplates)[keyof typeof tracking.defaultEmailTemplates],
  ][];

  const handleStatusToggle = (statusValue: string) => {
    setSelectedStatuses((prev) =>
      prev.includes(statusValue)
        ? prev.filter((s) => s !== statusValue)
        : [...prev, statusValue]
    );
  };

  const handleSelectAll = () => {
    setSelectedStatuses(templatesList.map(([_, template]) => template.type));
  };

  const handleUnselectAll = () => {
    setSelectedStatuses([]);
  };

  const handleNext = () => {
    setStep(2);
  };

  const handleBack = () => {
    setStep(1);
  };

  const handleConfirm = (enableWorkflows: boolean) => {
    onConfirm(selectedStatuses as GenerateDefaultTemplatesRequestDto["trackingStatuses"], enableWorkflows);
    setSelectedStatuses([]);
    setStep(1);
  };

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setSelectedStatuses([]);
      setStep(1);
    }
    onOpenChange(newOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh]">
        {step === 1 ? (
          <StatusSelectionStep
            selectedStatuses={selectedStatuses}
            onStatusToggle={handleStatusToggle}
            onSelectAll={handleSelectAll}
            onUnselectAll={handleUnselectAll}
            onCancel={() => handleOpenChange(false)}
            onNext={handleNext}
          />
        ) : (
          <ConfirmationStep
            selectedStatuses={selectedStatuses}
            onBack={handleBack}
            onConfirm={handleConfirm}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
